import React from "react";
import { ShimmerLine } from "../../../../../components/Shimmer/ShimmerLine/ShimmerLine";
import { SlotStack, SlotStackItem } from "../../../../../components/Stacks/SlotStack/SlotStack";
import { Stack, StackItem } from "../../../../../components/Stacks/Stack/Stack";
import { useViewport } from "../../../../../styles";
import { ListItemCanvas } from "../../shared/ListItemCanvas";
import { ListItemShimmerProps } from "../../shared/props";

export const SimpleFeedListItemShimmer: React.FC<ListItemShimmerProps> = ({ backgroundColor }) => {

    const viewportType = useViewport();

    let totalSlots: number;

    let actionStackItemsSlots: number;
    let mediaSlots: number;

    // tslint:disable: no-magic-numbers
    switch (viewportType) {
        case "s":
            totalSlots = 4;
            actionStackItemsSlots = 1;
            mediaSlots = totalSlots - actionStackItemsSlots;
            break;

        case "m":
        case "l":
            totalSlots = 6;
            actionStackItemsSlots = 2;
            mediaSlots = totalSlots - actionStackItemsSlots;
            break;

        case "xl":
            totalSlots = 12;
            actionStackItemsSlots = 2;
            mediaSlots = totalSlots - actionStackItemsSlots;
            break;

        case "xxl":
        case "xxxl":
            totalSlots = 12;
            actionStackItemsSlots = 2;
            mediaSlots = totalSlots - actionStackItemsSlots - 1; // minus 1 for the last unused column
            break;
    }

    return (

        <ListItemCanvas backgroundColor={backgroundColor}>
            <SlotStack totalSlots={totalSlots}>
                <SlotStackItem slots={mediaSlots}>
                    <Stack horizontal={true} height={49} verticalAlign="center">
                        <StackItem padding="0 0 0 16px">
                            <ShimmerLine height={32} width={32} />
                        </StackItem>
                        <StackItem padding="0 0 0 8px">
                            <ShimmerLine
                                height={20}
                                width={viewportType === "s" || viewportType === "m" ? 145 : 277}
                            />
                        </StackItem>
                    </Stack>
                </SlotStackItem>
                <SlotStackItem slots={actionStackItemsSlots}>
                    <Stack horizontal={true} height={49} verticalAlign="center">
                        <StackItem>
                            <ShimmerLine
                                height={14}
                                width={viewportType === "s" || viewportType === "m" ? 14 : 150}
                            />
                        </StackItem>
                    </Stack>
                </SlotStackItem>
            </SlotStack>
        </ListItemCanvas>
    );
};
